import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconComponent } from './icon.component';
import { IconGroupComponent } from './icon-group.component';

@NgModule({
  declarations: [
    IconComponent,
    IconGroupComponent
  ],
  imports: [
    CommonModule
  ],
  providers: [],
  exports: [
    IconComponent,
    IconGroupComponent
  ]
})
export class IconModule { }
